export default "__VITE_ASSET__D5ZAE_zc__"